<template>
  <div class="taskProcess">
    <template v-if="isQueue">
      <prePage></prePage>
    </template>
    <template v-else>
      <processAnimate @revoke="revoke"></processAnimate>
    </template>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {checkDeduction} from "@/api/common";
import {getStatus, getCatelogue, getEvaluation, getBaseData, getResult} from "@/api/word";
import prePage from "@/views/word/processPage/prePage";
import processAnimate from "@/views/word/processPage/processAnimate";

export default {
  name: "taskProcess",
  components: {
    prePage,
    processAnimate
  },
  data() {
    return {
      isQueue: true,
      timer: null,
      isGetCatelogue: false,
      isGetEvaluation: false,
      isGetBaseData: false,
      deduction: false
    }
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    /**
     * 查询检查状态
     * # 0 未开始 1 检查中 2转换html完成 3查询文件结束 4评估完成 5可以获取基本信息结构 100 检查完成 -1 检查失败
     */
    async getStatus() {
      try {
        let res = await getStatus({
          project: this.projectId,
          sign_name: this.sign_name,
          timeStamp: (new Date()).getTime()
        })
        let status = res.data.process;
        this.setProcessData(res.data);
        if (status == -1) {
          this.$confirm('检查发生错误，请返回重新检查。', '提示', {
            showClose: false,
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
            this.$router.push('/')
          }).catch(() => {
          });
          return
        }
        if (status < 100) {
          this.setFinished(false);
          // 获取文件目录
          if (status >= 1) {
            if (!this.isGetCatelogue) {
              await this.getCatelogue()
              this.isGetCatelogue = true;
            }
            this.isQueue = true
          }
          if (status >= 4) {
            if (!this.isGetCatelogue) {
              await this.getCatelogue()
              this.isGetCatelogue = true;
            }
            if (!this.isGetEvaluation) {
              await this.getEvaluation()
              this.isGetEvaluation = true;
            }
            this.isQueue = false;
          }
          if (status >= 5) {
            if (!this.isGetCatelogue) {
              await this.getCatelogue()
              this.isGetCatelogue = true;
            }
            if (!this.isGetEvaluation) {
              await this.getEvaluation()
              this.isGetEvaluation = true;
            }
            if (!this.isGetBaseData) {
              await this.getBaseData();
              this.isGetBaseData = true;
            }
            this.isQueue = false

          }
          this.timer = setTimeout(() => {
            this.getStatus()
          }, 1000 * 5)
        } else {
          console.log("检查完成了")
          if (!this.isGetCatelogue) {
            await this.getCatelogue()
            this.isGetCatelogue = true;
          }
          if (!this.isGetEvaluation) {
            await this.getEvaluation()
            this.isGetEvaluation = true;
          }
          if (!this.isGetBaseData) {
            await this.getBaseData();
            this.isGetBaseData = true;
          }
          this.isQueue = false;

          this.setFinished(true);
          // this.getResult()
          this.checkDeduction();
          // this.$router.push("/wordResult")
        }
      } catch (err) {
        console.log(err)
      }
    },
    revoke(){
      clearTimeout(this.timer);
      this.$router.push({
        name:"Home",
        params:{
          init:true
        }
      })
    },
    /**
     * 查询目录
     */
    async getCatelogue() {
      let res = await getCatelogue({
        project: this.projectId,
        sign_name: this.sign_name
      });
      console.log(res, "查询到文件目录")
      this.setCatelogueData(res.data)
    },

    /**
     * 获取评估信息
     */
    async getEvaluation() {
      let res = await getEvaluation({
        project: this.projectId,
        sign_name: this.sign_name
      })

      console.log(res, "查询到评估信息")
      this.setEvaluationData(res.data)
    },
    /**
     * 获取基本结构
     */
    async getBaseData() {
      let res = await getBaseData({
        project: this.projectId,
        sign_name: this.sign_name
      })
      console.log(res, "获取到基本结构信息")
      this.setBaseData(res.data)
    },
    async getResult() {
      let res = await getResult({
        project: this.projectId,
        sign_name: this.sign_name,
        vipServiceGuid: this.serviceInfo.vipServiceGuid
      });
      let data = res.data;
      this.deduction = data.deduction;
      if (!this.deduction) {
        this.$router.push("/wordMiddleResult")
      } else {
        this.$router.push('/wordResult')
      }

    },
    /**
     * 查询是否扣次
     */
    async checkDeduction(){
      let res = await checkDeduction({
        project: this.projectId,
        sign_name: this.sign_name
      });
      if(res.data){
        this.$router.push('/wordResult')
        // this.$router.push("/wordMiddleResult")
      }else{
        this.$router.push("/wordMiddleResult")
      }
    },
    ...mapMutations('word', ['setProcessData', 'setEvaluationData', 'setBaseData', 'setFinished', 'setCatelogueData'])
  },
  computed: {
    ...mapState('word', ['sign_name', 'projectId']),
    ...mapState('user',['serviceInfo'])
  }
}
</script>

<style lang="scss" scoped>
.taskProcess {
  flex: 1;
  height: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

}
</style>
